export default __webpack_public_path__ + "static/media/remove-square.2798dcc9.svg";